var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Curriculum } from '@/models/Curriculum';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import CurriculumForm from '@/views/Curricula/CurriculumForm';
import { activeHtml } from '@/support/String';
import ErrorHandler from '@/support/ErrorHandler';
let Curricula = class Curricula extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Curricula';
        this.breadcrumbs = [];
        this.selected = [];
        this.isDisplayingCurriculumForm = false;
        this.loading = true;
        this.selectedCurriculum = null;
        this.isShowingDialog = false;
        this.isImporting = false;
    }
    get tableOptions() {
        return {
            model: new Curriculum(),
            name: {
                singular: 'Curriculum',
                plural: 'Curricula',
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    action: '/curricula/{id}',
                    editable: true,
                    changed: false,
                    transform: (name, curriculum) => (curriculum.is_current ? activeHtml(name) : name),
                },
            ],
            actions: [
                {
                    type: 'active',
                    label: 'active',
                    icon: 'beenhere',
                    action: this.setActive,
                },
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: '/curricula/{id}',
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, curriculum) => {
                        this.selectedCurriculum = curriculum;
                        this.$store.dispatch('openDialog', this.dialogOptions);
                    },
                },
            ],
        };
    }
    get dialogOptions() {
        const curriculum = this.selectedCurriculum;
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.curriculum') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!curriculum) {
                            return;
                        }
                        curriculum
                            .delete()
                            .then(() => {
                            this.refreshDataTable();
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedCurriculum = new Curriculum();
                    },
                },
            },
        };
    }
    mounted() {
        this.breadcrumbs.push({ name: this.$tc('library.title'), path: '/curricula' });
    }
    showCurriculumForm() {
        this.isDisplayingCurriculumForm = true;
    }
    setActive(dataTable, curriculum) {
        curriculum.update({ is_current: true }).then((curriculum) => {
            dataTable.refresh();
        });
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
};
Curricula = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            CurriculumForm,
        },
    })
], Curricula);
export default Curricula;
